import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders, HttpParams} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { AppSettings } from '../config/AppSettings';
import {GridPage} from '../util/components/gridtable/gridtable.component';
import { AppUserModel } from '../models/appUser.Model';
import { SortClass } from "../modules/util.class";
import { CommunityModel } from '../models/community.model';
@Injectable()
export class ChargingConfigService {

  constructor(private http: HttpClient, private appsetting : AppSettings) { } 
  
 
      getConfig(evseid: string) {
        let header = new HttpHeaders();
        let param: HttpParams = new HttpParams();
        param = param.append("evseid", evseid.toString());
        return this.http
          .get(this.appsetting.get("server-url") + "/api/getEVSEkeys", {
            headers: header,
            observe: "body",
            params: param,
            responseType: "json"
          })
          .map(res => res);
      }
      setKeyConfig(evseid: string,keyname:string,newvalue:string) {
        let header = new HttpHeaders();
        let param: HttpParams = new HttpParams();
        param = param.append("evseid", evseid.toString());
        param = param.append("keyname", keyname.toString());
        param = param.append("newvalue", newvalue.toString());
        return this.http
          .get(this.appsetting.get("server-url") + "/api/changeEVSEkeys", {
            headers: header,
            observe: "body",
            params: param,
            responseType: "json"
          })
          .map(res => res);
      }
  /* deleteUser(username : string) {
      let header = new HttpHeaders();
      let param : HttpParams=new HttpParams();
      param=param.append("username", username);         
      return this.http.post( this.appsetting.get("server-url") + '/api/AppUserDeletion',
        {headers : header,observe : "body", params : param,responseType : "json"})
      .map(res=>res);
    }
    inactiveUser(username : string) {
      let header = new HttpHeaders();
      let param : HttpParams=new HttpParams();
      param=param.append("username", username);     
      let objUser : AppUserModel = new AppUserModel();
      objUser.username=username;
      return this.http.get(this.appsetting.get("server-url") + "/api/AppUserDeletionbyname", {
        headers: header,
        observe: "body",
        params: param,
        responseType: "json"
      })
      .map(res=>res);
    }

    approveRFIDRequest(username: string){
      let header = new HttpHeaders();
      let param: HttpParams = new HttpParams();
      param = param.append("username", username.toString());
      return this.http.get(this.appsetting.get("server-url") + "/api/approverfidrequest", {
          headers: header,
          observe: "body",
          params: param,
          responseType: "json"
        })
        .map(res => res);

    }*/

    getAllCommunity(scope:String) {
      let header = new HttpHeaders();
      let httpParam : HttpParams=new HttpParams();
     httpParam=httpParam.append("scope", scope.toString());
    //  httpParam=httpParam.append("size",pageinfo.size.toString());
     //httpParam=httpParam.append("status",searchField.status);
    // httpParam=httpParam.append("startdate", this.tools.formatDateToDDMMMYY(searchField.startdate));
    //  httpParam=httpParam.append("enddate",this.tools.formatDateToDDMMMYY(searchField.enddate));    
      //  httpParam = httpParam.append("username", searchField.searchText);
        return this.http.get( this.appsetting.get("server-url") + '/api/allcommunity',{headers : header, observe : "body", params : httpParam,responseType : "json"})
      .map(res=>res);
    }
  
}
